import React from 'react'

import ContractorProfileHeader from '../../../../components/contractor-profile-header'
import FormFactory from '../../../../components/form/form-factory'

import * as S from './styles'

import IProps from './props'

const EditHeaderContractor = ({
  headerInfo,
  onSubmit,
  errorMessage,
  dataForm,
}: IProps) => (
  <S.Container>
    <ContractorProfileHeader contractor={headerInfo} />
    <S.FormContainer>
      <FormFactory
        data={dataForm}
        onSubmit={onSubmit}
        submitErrorMessage={errorMessage}
      />
    </S.FormContainer>
  </S.Container>
)

export default EditHeaderContractor
